<template>
    <v-form class="co-formulario-opcional-assinatura-eletronica">
        <rejeicao-documento
            :value="novoSignatario"
        />
        <nome-signatario
            v-model="novoSignatario"
            descricao
        />
        <convidar-por-sms
            v-if="!assinaturaPresencial"
            :value="novoSignatario"
            :desabilitar-campo="modoEdicao"
            @abrir-dialog-contratar-servico="abrirDialogContratarServico"
        />
        <enviar-token-sms
            :value="novoSignatario"
            :desabilitar-campo="modoEdicao"
            @abrir-dialog-contratar-servico="abrirDialogContratarServico"
        />
        <telefone-signatario
            :value="novoSignatario"
            :campo-requerido="telefoneRequired"
            descricao
        />
        <chave-seguranca
            v-if="!assinaturaPresencial"
            :value="novoSignatario"
        />
        <mensagem-email-signatario
            v-if="!assinaturaPresencial"
            :value="novoSignatario"
        />

        <dialog-contratar-servico
            :dialog="dialogContratarServico"
            @fechar="fecharDialogContratarServico"
        />
    </v-form>
</template>

<script>
import ConvidarPorSms from '../campos-formulario/ConvidarPorSms'
import EnviarTokenSms from '../campos-formulario/EnviarTokenSms'
import TelefoneSignatario from '@/commons/components/text-field/TelefoneSignatario'
import ChaveSeguranca from '../campos-formulario/ChaveSeguranca'
import DialogContratarServico from '@/commons/components/DialogContratarServico'
import MensagemEmailSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/MensagemEmailSignatario'
import RejeicaoDocumento
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/RejeicaoDocumento'
import NomeSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/NomeSignatario'

export default {
    name: 'FormularioOpcionalAssinaturaEletronica',
    components: {
        RejeicaoDocumento,
        MensagemEmailSignatario,
        DialogContratarServico,
        ChaveSeguranca, ConvidarPorSms, EnviarTokenSms, TelefoneSignatario,
        NomeSignatario
    },
    props: {
        novoSignatario: {
            type: Object,
            required: true
        },
        modoEdicao: {
            type: Boolean
        }
    },
    data() {
        return {
            dialogContratarServico: false
        }
    },
    computed: {
        assinaturaPresencial() {
            return this.novoSignatario.disponibilidadeAssinatura === 'PRESENCIAL'
        },
        telefoneRequired() {
            return this.novoSignatario.enviarConviteSMS || this.novoSignatario.enviarTokenSMS
        }
    },
    methods: {
        abrirDialogContratarServico() {
            this.dialogContratarServico = true
        },
        fecharDialogContratarServico() {
            this.dialogContratarServico = false
        }
    }
}
</script>

<style lang="stylus" scoped>
.co-formulario-opcional-assinatura-eletronica
    padding 7px 0 0 9px
</style>